export default "__VITE_ASSET__f62fe47d__"